export default __webpack_public_path__ + "slices/main/assets/public/media/logos/forbes.935137163135bf0b7678e2c7b044028c.png";